import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M17.25 10h-.5V7.75C16.75 5.131 14.619 3 12 3S7.25 5.131 7.25 7.75V10h-.5C5.79 10 5 10.79 5 11.75v7.5c0 .96.79 1.75 1.75 1.75h10.5c.96 0 1.75-.79 1.75-1.75v-7.5c0-.96-.79-1.75-1.75-1.75zm-3.841 7.681a.25.25 0 0 1-.24.319h-2.337a.25.25 0 0 1-.24-.319l.679-2.378A1.493 1.493 0 0 1 10.5 14a1.5 1.5 0 0 1 3 0c0 .562-.313 1.046-.771 1.303l.68 2.378zM8.75 10V7.75c0-1.792 1.458-3.25 3.25-3.25s3.25 1.458 3.25 3.25V10h-6.5z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'LockFill');

export default Icon;
